// extracted by mini-css-extract-plugin
export default {"tag":"current-filter-tag_tag__7FJ8e","labelPrefix":"current-filter-tag_labelPrefix__faK8e"};